import { analyticsTrackEvent } from '@core/utils/analytics';
import {
  HOME_TOUR_COMPLETED,
  HOME_TOUR_DISMISSED,
  HOME_TOUR_PROMPT_SHOWN,
  HOME_TOUR_SKIPPED,
  HOME_TOUR_STARTED,
  HOME_TOUR_STEP_VIEWED,
} from '@core/constants/analytics';
import type { TourSource } from '@app/shared/tour';

/** Set to true once analytics fields are finalized. */
const HOME_TOUR_ANALYTICS_ENABLED = false;

const ITEM_TYPE = 'HomeTour';

export type HomeTourSource = TourSource;

type TourStepProps = {
  stepId?: string;
  stepIndex?: number;
  totalSteps?: number;
  source?: TourSource;
};

export const trackHomeTourPromptShown = () => {
  if (!HOME_TOUR_ANALYTICS_ENABLED) return;
  analyticsTrackEvent(HOME_TOUR_PROMPT_SHOWN, { itemType: ITEM_TYPE });
};

export const trackHomeTourDismissed = () => {
  if (!HOME_TOUR_ANALYTICS_ENABLED) return;
  analyticsTrackEvent(HOME_TOUR_DISMISSED, { itemType: ITEM_TYPE });
};

export const trackHomeTourStarted = (source: HomeTourSource) => {
  if (!HOME_TOUR_ANALYTICS_ENABLED) return;
  analyticsTrackEvent(HOME_TOUR_STARTED, { itemType: ITEM_TYPE, source });
};

export const trackHomeTourStepViewed = ({
  stepId,
  stepIndex,
  totalSteps,
  source,
}: TourStepProps) => {
  if (!HOME_TOUR_ANALYTICS_ENABLED) return;
  analyticsTrackEvent(HOME_TOUR_STEP_VIEWED, {
    itemType: ITEM_TYPE,
    stepId,
    stepIndex,
    totalSteps,
    source,
  });
};

export const trackHomeTourCompleted = ({
  totalSteps,
  source,
}: TourStepProps) => {
  if (!HOME_TOUR_ANALYTICS_ENABLED) return;
  analyticsTrackEvent(HOME_TOUR_COMPLETED, {
    itemType: ITEM_TYPE,
    totalSteps,
    source,
  });
};

export const trackHomeTourSkipped = ({
  stepId,
  stepIndex,
  totalSteps,
  source,
}: TourStepProps) => {
  if (!HOME_TOUR_ANALYTICS_ENABLED) return;
  analyticsTrackEvent(HOME_TOUR_SKIPPED, {
    itemType: ITEM_TYPE,
    stepId,
    stepIndex,
    totalSteps,
    source,
  });
};
